import { TrackingType } from 'components/package/expedia/enums';
import { TrackingState } from 'components/package/expedia/interfaces';

import { IProgramRelationship } from 'models';

function getInitialTrackingState(activeProgram: IProgramRelationship): TrackingState {
  return {
    // trackingType: TrackingType.NONE,
    trackingType: TrackingType.PZ,
    trackingInformationPZCamref: activeProgram?.camRef ?? '',
    trackingInformationPZPubref: '',
  };
}

export { getInitialTrackingState };
